import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { Shield, Award, Star } from "lucide-react";

const OverviewSection = () => {
  const { t } = useTranslation();

  const cards = [
    { icon: Shield, title: t("overview.card1Title"), desc: t("overview.card1Desc") },
    { icon: Award, title: t("overview.card2Title"), desc: t("overview.card2Desc") },
    { icon: Star, title: t("overview.card3Title"), desc: t("overview.card3Desc") },
  ];

  return (
    <section id="overview" className="py-20 lg:py-28 bg-secondary">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="text-xs font-body font-semibold tracking-[0.2em] uppercase text-accent mb-3 block">
            {t("overview.badge")}
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-display font-bold text-foreground mb-4">
            {t("overview.title")}
          </h2>
          <p className="text-lg font-display italic text-accent mb-6">
            {t("overview.subtitle")}
          </p>
          <p className="text-base text-muted-foreground font-body max-w-2xl mx-auto">
            {t("overview.description")}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {cards.map((card, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.15 }}
              className="bg-card rounded-lg p-8 shadow-card hover:shadow-elegant transition-shadow group"
            >
              <div className="w-12 h-12 rounded-full bg-accent/10 flex items-center justify-center mb-5 group-hover:bg-accent/20 transition-colors">
                <card.icon className="h-6 w-6 text-accent" />
              </div>
              <h3 className="text-lg font-display font-semibold text-foreground mb-3">
                {card.title}
              </h3>
              <p className="text-sm text-muted-foreground font-body leading-relaxed">
                {card.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OverviewSection;
